import { Col } from '@uswitch/ev-core/react'
import { List, ListItem } from '../../elements/trustyle-list'

const Column = ({ items, title, variant, ...props }) => (
  <Col span={1} {...props}>
    <List title={title} variant={variant}>
      <For each='item' of={items} index='i'>
        <ListItem key={i}>{item}</ListItem>
      </For>
    </List>
  </Col>
)

export default Column
